// Module I — New Member Onboarding (Onboarding Journey)
// Pipeline de nuevos miembros: welcome call → records → first appointment → HRA.

import MemberOnboardingPage from "./pages/MemberOnboardingPage";

// Export routes for AppRouter
export const memberOnboardingRoutes = [
  {
    path: "/member-onboarding",
    element: <MemberOnboardingPage />,
  },
];

// Export components for external use
export { default as MemberOnboardingPage } from "./pages/MemberOnboardingPage";
